import { URLService, UrlQueryService } from './url.service';
function defaultNumberConvert(val) {
  let returnVal = Number(val);
  if (isNaN(returnVal)) {
    return 0;
  }
  return returnVal;
}
const queryKeys = [
  { name: 'dealerId', type: Number }, // 经销商ID
  { name: 'openType', type: String }, // 打开弹层类型 openType:[activity, promotion, promotionActivity]
  { name: 'actId', type: Number }, // 活动id
  { name: 'pvAreaId', type: Number }, // 流量入口
  { name: 'sceneType', type: String }, // 场景类型 scenetype:[3d,full]
  { name: 'hallType', type: String }, // 展馆类型 hallType:[3d]
  { name: 'from', type: String }, // 来源 ， 已废弃建议使用busi [cloudvideo,bdxiaochengxu,xiaochengxu,sahuan,tuan]
  { name: 'userId', type: Number }, // 用户标识
  { name: 'recommendSeriesId', type: Number }, // 推荐车系id
  { name: 'busi', type: String }, // 业务来源  [smartstore, smartadvert, icsapp]
  { name: 'activityId', type: Number }, // 活动id
  { name: 'isPop', type: String }, //
  { name: 'vrMode', type: String }, // 展馆模式
  { name: 'backUrl', type: String }, // 返回地址
  { name: 'siteId', type: Number }, // siteId
  { name: 'fromPvAreaId', type: Number }, // 上级页面pvareaid
  { name: '_isDebug', type: String }, // 是否调试模式
  { name: 'removeLeaveIntercept', type: Number }, // 是否删除拦截缓存
  { name: 'activityType', type: Number },
  { name: 'promotionId', type: String }, // 分享海报打开链接活动类型
  { name: 'subjectTypeId', type: Number }, // 专题id
  { name: 'scene_code', type: Number },
  { name: 'seriesId', type: Number },
  { name: 'cityId', type: Number }, // 城市id
  { name: 'salesId', type: Number },
  { name: 'realtimeanswer', type: Number }, //是否B端打开
  { name: 'userType', type: String },
  { name: 'dealerIds', type: String },
  { name: 'uiType', type: String },
  { name: 'eid', type: String },
  { name: 'deviceId', type: String }, // 设备Id
  { name: 'floor', type: Number }, // 楼层id
];
function getFunc(urlQuery, hashQuery, queryKey) {
  let key = queryKey.name;
  let paramType = queryKey.type;
  let convertFunc = queryKey.convertFunc;
  let val = urlQuery.get(key) || hashQuery.get(key);
  if (val && paramType === Number) {
    convertFunc = convertFunc || defaultNumberConvert;
    let returnVal = convertFunc(val);
    return returnVal;
  }
  return val;
}
const queryParams = {
  init: function (url) {
    url = url || window.location.href;
    const currentUrl = new URLService(url);
    // 处理 http://dealer.m.autohome.com.cn/vr/62669/index.html?busi=smartstore#pvareaid=62669 的情况
    const hashQuery = new UrlQueryService(currentUrl.fragment);
    let len = queryKeys.length;
    for (let i = 0; i < len; i++) {
      let queryKey = queryKeys[i];
      let key = queryKey.name;
      Object.defineProperty(queryParams, key, {
        configurable: true,
        get() {
          return getFunc(currentUrl.queryParams, hashQuery, queryKey);
        },
      });
    }
  },
  clear() {
    let len = queryKeys.length;
    for (let i = 0; i < len; i++) {
      let queryKey = queryKeys[i];
      let key = queryKey.name;
      delete queryParams[key];
    }
  },
};

export default queryParams;
